import { formatLimit, formatUsd } from "@/lib/displayFormat";
export function MoneyText({
  value,
  limit = false,
}: {
  value: string | number;
  limit?: boolean;
}) {
  return (
    <span className="tabular-nums">
      {limit ? formatLimit(value) : formatUsd(value)}
    </span>
  );
}
